<template>
  <div class="video-record">
    <div class="videoRec items-center">
      <input type="hidden" ref="video_h" name="video" v-model="videoModel" />
      <video width="100%" ref="video" class="video" :poster="poster"></video>
      <div class="video-controllers mb-3"></div>
      <vs-row class="w-full items-center" style="justify-content: center;">
        <vs-button
          v-if="stopDisabled"
          class="mr-3"
          size="large"
          @click="startRecording('video1')"
          :disabled="startDisabled"
          icon-pack="material-icons"
          icon="radio_button_unchecked"
          color="#DC0032"
          typed="filled"
        ></vs-button
        >
        <vs-button
          v-else
          class="mr-3"
          color="#DC0032"
          size="large"
          @click="stopRecording('video1')"
          :disabled="stopDisabled"
          icon-pack="material-icons"
          icon="radio_button_checked"
          ></vs-button
        >
        <vs-button
          radius
          class="mr-3"
          size="large"
          color="primary"
          type="border"
          @click="playRecording('video1')"
          :disabled="playDisabled"
          icon-pack="material-icons"
          :icon="playMode ? 'pause' : 'play_arrow'"
          ></vs-button
        >
        <vs-button
          radius
          type="border"
          class="mr-3"
          size="large"
          color="primary"
          @click="uploadRecording('video1')"
          :disabled="true"
          icon-pack="material-icons"
          icon="cloud_upload"
          ></vs-button
        >
        <vs-button
          radius
          type="border"
          size="large"
          color="primary"
          @click="resetRecording('video1')"
          :disabled="resetDisabled"
          icon-pack="material-icons"
          icon="restore"
          ></vs-button
        >
      </vs-row>
      <!-- <vs-button size="small" @click="download('video1')"
        ><v-icon>Play</v-icon></vs-button
      > -->
    </div>
  </div>
</template>

<script>
// import {Api} from '@/utilities/api'

const RecordRTC = require("recordrtc");

export default {
  name: "RecordVideo",
  data() {
      return {
        poster: "/static/video-camera.png",
        videoModel: "",
        recordingStarted: false,
        recordingCompleted: false,
      }
  },
  computed: {
    startDisabled() {
      return this.recordingStarted || this.recordingCompleted;
    },
    stopDisabled() {
      return !this.recordingStarted;
    },
    playDisabled() {
      return !this.recordingCompleted;
    },
    resetDisabled() {
      return !this.recordingCompleted;
    },
    playMode() {
      if(this.video) return this.video.playing;
      else return false;
    }
  },
  methods: {
    playRecording() {
      this.video.volume = 1;
      this.video.play();
    },
    resetRecording() {
      this.video.srcObject = null;
      this.video.src = null;
      this.video.muted = false;
      this.video.controls = false;
      this.video.autoplay = false;
      this.video.volume = 0;

      this.recordingStarted = false;
      this.recordingCompleted = false;
    },
    successCallback(stream) {
      this.recordingStarted = true;
      var options = {
        mimeType: "video/webm", // "video/webm;codecs=vp9", // or video/webm\;codecs=h264 or video/webm\;codecs=vp9
        audioBitsPerSecond: 51200000,
        videoBitsPerSecond: 51200000,
        // timeSlice: 2000,
        // bitsPerSecond: 128000, // if this line is provided, skip above two
      };
      this.stream = stream;
      this.video.muted = true;
      this.video.volume = 0;
      this.video.srcObject = stream;
      this.video.play();

      this.recordRTC = RecordRTC(stream, options);
      this.recordRTC.startRecording();
    },
    errorCallback() {
      //handle error here
    },
    processVideo() {
      this.recordingStarted = false;
      this.recordingCompleted = true;

      this.video.srcObject = null;
      this.video.muted = false;
      this.video.volume = 1;
      var recordedBlob = this.recordRTC.getBlob();
      this.stream.getTracks().forEach((track) => track.stop());
      this.video.src = URL.createObjectURL(recordedBlob);
      this.recordRTC.getDataURL(function (dataURL) {});
    },
    startRecording(video = "video") {
      let mediaConstraints = {
        video: { width: 1920, height: 1080 },
        audio: true,
      };
      navigator.mediaDevices
        .getUserMedia(mediaConstraints)
        .then((stream) => {
          this.successCallback(stream);
        })
        .catch((err) => {
          throw err;
        });
    },
    stopRecording(video = "video") {
      let recordRTC = this.recordRTC;
      recordRTC.stopRecording(() => {
        this.processVideo();
      });
      let stream = this.stream;
      // stream.getTracks().forEach((track) => track.stop());
      //stream.getVideoTracks().forEach((track) => track.stop());
    },
    download(video = "video") {
      this.recordRTC.save("video.webm");
    },
  },
  mounted() {
    this.video = this.$refs.video;
    this.video.muted = false;
    this.video.controls = false;
    this.video.autoplay = false;
    this.video.volume = 0;
  }
};
</script>

<style scoped>
.video {
  /*box-shadow: 1px 6px 10px 2px rgba(35, 35, 35, 0.62);*/
  /*height: 400px;*/
  max-height: 400px;
  object-fit: none;
  background-color: black;
  border-radius: 12px;
}
</style>